import { useQuery } from '@tanstack/vue-query'
import { getPortfolioOverview } from '../portfolioEndpoints'
import { portfolioKeys } from '../portfolioQueryKeys'

export function usePortfolioOverviewQuery() {
  return useQuery({
    queryKey: portfolioKeys.overview(),
    queryFn: getPortfolioOverview,
  })
}
